import { useCallback } from 'react'
import { deleteSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { BIUrlOptions } from 'Pages/BusinessLogistics/BI/Page/@signals'
import { useToast } from '@hooks'


export default function useDeleteUrl() {
	const { showToast } = useToast()

	const handleDeleteUrl = useCallback(id => {
		const backupOptions = BIUrlOptions.peek()
		BIUrlOptions.value = BIUrlOptions.value.filter(({value}) => value !== id)
		deleteSubmit(`${BACKEND_APIS.DASHBOARD}/delete-filters?id=${id}`)
			.catch(() => {
				showToast.error('Error deleting url')
				BIUrlOptions.value = backupOptions
			})
	}, [])

	return {
		handleDeleteUrl
	}
}